export const AGENT_LOGIN = 'AGENT_LOGIN'
export const CONNECT_AGENT = 'CONNECT_AGENT'
export const DISCONNECT_AGENT = 'DISCONNECT_AGENT'
export const LOAD_AGENT_CONNECTION = 'LOAD_AGENT_CONNECTION'
export const LOAD_AGENT_CONVERSATIONS = 'LOAD_AGENT_CONVERSATIONS'
export const LOAD_CONVERSATIONS = 'LOAD_CONVERSATIONS'
export const LOAD_MESSAGES = 'LOAD_MESSAGES'
